import React from 'react';
interface CreditNoteHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    email: string;
    gstRegNo: string;
  };
  creditNote: {
    number: string;
    issueDate: string;
    bookingRef: string;
    customerRef: string;
    staff: string;
  };
}
export function CreditNoteHeader({
  company,
  creditNote
}: CreditNoteHeaderProps) {
  return <>
      {/* Top Row: Logo Left, Address Right */}
      <div className="flex justify-between items-start mb-4" data-id="element-201">
        {/* Left: Logo */}
        <div data-id="element-202">
          <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-md" data-id="element-203">
            <span className="text-white font-bold text-lg" data-id="element-204">MT</span>
          </div>
        </div>

        {/* Right: Company Address - Compact */}
        <div className="text-right" data-id="element-205">
          <h1 className="text-sm text-neutral-900 mb-1" data-id="element-206">{company.name}</h1>
          <div className="text-[10px] text-neutral-500 space-y-0.5 leading-relaxed" data-id="element-207">
            {company.address.map((line, i) => <p key={i} data-id="element-208">{line}</p>)}
            <p className="mt-1" data-id="element-209">
              Tel: {company.phone} | Email: {company.email}
            </p>
            <p data-id="element-210">GST Reg. No.: {company.gstRegNo}</p>
          </div>
        </div>
      </div>

      {/* CREDIT NOTE Title - Centered Above Box */}
      <h2 className="text-lg font-bold text-neutral-900 mb-2 tracking-tight text-center" data-id="element-211">
        CREDIT NOTE
      </h2>

      {/* Credit Note Details Box */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 mb-4" data-id="element-212">
        {/* Two Column Grid */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-1.5" data-id="element-213">
          {/* Left Column */}
          <div className="space-y-1.5" data-id="element-214">
            <div className="flex justify-between" data-id="element-215">
              <span className="text-xs font-medium text-neutral-600" data-id="element-216">
                Credit Note No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-217">
                {creditNote.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-218">
              <span className="text-xs font-medium text-neutral-600" data-id="element-219">
                Issue Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-220">
                {creditNote.issueDate}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-221">
              <span className="text-xs font-medium text-neutral-600" data-id="element-222">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-223">
                {creditNote.bookingRef}
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-1.5" data-id="element-224">
            <div className="flex justify-between" data-id="element-225">
              <span className="text-xs font-medium text-neutral-600" data-id="element-226">
                Customer Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-227">
                {creditNote.customerRef}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-228">
              <span className="text-xs font-medium text-neutral-600" data-id="element-229">
                Staff:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-230">
                {creditNote.staff}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>;
}